import React, { createContext, useContext, useEffect, useState } from 'react';

const TelegramContext = createContext({
    user: null,
    webApp: null,
    referralParam: null,
});

export const useTelegram = () => useContext(TelegramContext);

export const TelegramProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [webApp, setWebApp] = useState(null);
    const [referralParam, setReferralParam] = useState(null);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;

        if (tg) {
            tg.ready();
            setWebApp(tg);

            if (tg.initDataUnsafe?.user) {
                setUser(tg.initDataUnsafe.user);
            } else {
                console.warn("No user data found in Telegram WebApp");
            }

            const urlParams = new URLSearchParams(window.location.search);
            const referralFromUrl = urlParams.get("referral");
            if (referralFromUrl) {
                setReferralParam(referralFromUrl);
            } else if (tg.initDataUnsafe?.start_param) {
                setReferralParam(tg.initDataUnsafe.start_param);
            } else {
            }
        }
    }, []);

    return (
        <TelegramContext.Provider value={{ user, webApp, referralParam }}>
            {children}
        </TelegramContext.Provider>
    );
};